"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.form.hero.title': 'Lorem ipsum dolor',
    'register.form.hero.description': 'Please use this form to register.',
    'register.form.hero.login_link_text': 'If you are already a member, please',
    'register.form.hero.login_link': 'login here.',
};
